import { isEmpty } from 'lodash';
import React from 'react';

import {
	AutoRefillIcon, CartItemWrapper,TotalWrapper
} from './styles';

const toReadableBusinessLine = (businessLine) => {
	const mapping = {
		LASH: 'eyelashes',
		HAIR: 'male pattern baldness',
		FILI: 'fine lines/wrinkles',
		ROSE: 'rosacea',
		ACNE: 'acne or rosacea',
		TRET: 'fine lines/wrinkles',
		HYPE: 'hyperpigmentation', // 'hyperpigmentation/dark spots' is too long
	};
	return mapping[businessLine]
};


const CartItem = ({
	type,
	description,
	conditionsTreated,
	deleteable,
	autorefill = {},
	cost,
	dispatcher,
	medCheckout,
	index,
	isFollowup,
}) => {
	let outterStyles = {}
	if (medCheckout) {
		outterStyles = {
			padding: '10px 10px',
			backgroundColor: 'white',
		}
		if (type === 'total') {
			outterStyles.fontWeight = 900
		} else if (type === 'product_summary') {
			outterStyles.color = '#000000'
		}
	}
	return (
		<CartItemWrapper $medCheckout={medCheckout} $type={type} $isFollowup={isFollowup}>
			{!medCheckout && index != 0 && <hr/>}
			<div style={outterStyles} className={`cart-item ${type == 'total' ? 'cart-item-total' : ''}`}>
				<div className={`total ${type == 'total' ? 'cart-total-title' : 'cart-item-title'}`}>
					<div className="flex-start">
						{description}
					</div>
					{conditionsTreated &&
            <ul>
            	{conditionsTreated.map((condition, idx) => (
            		<li key={idx}>{toReadableBusinessLine(condition)}</li>
            	))}
            </ul>
					}
					{deleteable &&
            <span className="remove-promo" onClick={() => dispatcher.removePromoFromCart(promo.code)}>
            	<svg width="10" height="8" xmlns="http://www.w3.org/2000/svg">
            		<g stroke="#979797" fill="none" fillRule="evenodd" strokeLinecap="square">
            			<path d="M1 0l8 8M9 0L1 8"/>
            		</g>
            	</svg>
            </span>
					}
				</div>
				{medCheckout
					? <TotalWrapper>
						<div
							className={`${type == 'total' ? 'cart-total-price' : 'cart-item-price'}`}
							data-cy={`${type == 'total' ? 'CartTotalPrice' : `CartItemPrice_${type}`}`}
						>
							{cost}
						</div>
					</TotalWrapper>
					: <div className={`${type == 'total' ? 'cart-total-price' : 'cart-item-price'}`}>
						{cost}
					</div>
				}
			</div>
		</CartItemWrapper>
	);
};

export default CartItem;

